// Package Imports

// Internal Imports

export enum EValidSSOKey {
  VALID_SSO = "valid_sso",
}

export enum EQueryKeys {
  APP_TYPE = "app_type",
  REDIRECT_URI = "redirect_uri",
  ROUTE_TYPE = "route_type"
}

export enum ESessionStorageKeys {
  AUTH_TOKEN = "auth_token",
  REFRESH_TOKEN = "refresh_token",
  ID_TOKEN = "id_token",
  ORG_ID = "org_id",
}

export enum ESessionStorageFormKeys {
  SIGN_UP_FORM = "sso-sign-up-form",
}

export type USessionStorageKeys = ESessionStorageKeys | EValidSSOKey | EQueryKeys;

export enum ETimestampKeys {
  MFA_EMAIL_CODE = "sso_mfa_email_code_timestamp",
  MFA_SMS_CODE = "sso_mfa_sms_code_timestamp",
}

export type IUseInitSSOInput = {
  [key in EQueryKeys]: string | null;
}

export type IValidSSOState = {
  [key in EValidSSOKey]: boolean | null;
}

export type IInitSSOData = IUseInitSSOInput | null;
export type IInitSSOError = Error | null;

export interface IUseInitSSOOuput {
  initSSOLoading: boolean;
  initSSOData: IInitSSOData;
  initSSOError: IInitSSOError;
}

export type IUseSSODataOutput = IUseInitSSOInput & IValidSSOState;

export interface IAccountDetailsFormData {
  name: string;
  family_name: string;
  email: string;
  password: string;
  phone_number: string;
  gender: string;
}

export interface ISignUpMutationInput {
  email: string;
  gender: string;
  firstName: string;
  lastName: string;
  password: string;
  phoneNumber: string;
}

export interface IResendOTP {
  username: string;
  clientID: string;
}

export interface IAdminLogin {
  username: string;
  password: string;
  clientId: string;
}

export interface IAdminLoginOutput {
  AccessToken: string;
  ExpiresIn: number;
  IdToken: string;
  RefreshToken: string;
}

export type TSessionStorageInput = {
  key: ESessionStorageKeys;
  value: string;
}

export type TSessionStorageOutput = {
  [key in ESessionStorageKeys]: string | null;
}

export interface IAssignUserTypeGroupInput {
  username: string | null;
  email: string | null;
  groupname: string | null;
}

export interface IInviteDetail {
  email: string;
  inviteId: string;
  inviteResult: InviteResult;
}

export interface InviteResult {
  org_id: string;
  registration_country: string;
  updated_timestamp: Date;
  created_timestamp: Date;
  org_name: string;
  company_identification: CompanyIdentification;
  org_trading_name: string;
  invite: Invite;
  message: string | null;
}

export interface CompanyIdentification {
  enterprise_type: string;
  registered_name: string;
  trading_name: string;
  country_of_registration: string;
}

export interface Invite {
  user_type: string;
  redeemed_timestamp: null;
  created_timestamp: Date;
  expires_timestamp: Date;
  id: string;
  email: string;
  status: string;
}

export interface IRedeemInvitePayload {
  org_role: string;
  member_status: string;
  statutory_details: StatutoryDetails;
  contact_details: ContactDetails;
}

export interface ContactDetails {
  personal: Personal;
}

export interface Personal {
  email_address: string;
  mobile_number: string;
}

export interface StatutoryDetails {
  gender: string;
  first_name: string;
  last_name: string;
}

export interface IRedeemInviteInput {
  jwt: string;
  org_id: string;
  username: string;
  payload: IRedeemInvitePayload;
}

export interface IAddMemberInput {
  org_id: string;
  username: string;
  payload: IRedeemInvitePayload;
}


export type TAuthResultUserData = {
  token: string;
  refresh: string;
  sub: string;
  org_id: string;
}
